var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "thank__page" }, [
      _c(
        "div",
        {
          staticClass:
            "container d-flex align-items-center justify-content-center"
        },
        [
          _c("div", { staticClass: "thank__body" }, [
            _c("div", { staticClass: "text-center img" }, [
              _c("img", { attrs: { src: "/img/icon/Peace.svg", alt: "" } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "title text-center" }, [
              _c("p", { staticClass: "Raleway p-black max-max mb-0" }, [
                _c("b", [_vm._v("Thank you")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content text-center" }, [
              _c("p", { staticClass: "min" }, [
                _vm._v(
                  "Your review has been accepted and will be published soon."
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "submit__btn" }, [
              _c("div", { staticClass: "row justify-content-center" }, [
                _c("div", { staticClass: "col-md-6" }, [
                  _c(
                    "button",
                    { staticClass: "btn btn-green btn-full small" },
                    [_vm._v("nice!")]
                  )
                ])
              ])
            ])
          ])
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }